import { useEffect, useState } from "react";

function useKeyDown(target, callback) {
  // 获取目标键和修饰键
  const getTargetKeyAndModifiers = () => {
    if (typeof target === "string") {
      return { targetKey: target, metaKey: false, ctrlKey: false, shiftKey: false, altKey: false };
    } else if (typeof target === "object" && target !== null) {
      const { targetKey, metaKey = false, ctrlKey = false, shiftKey = false, altKey = false } = target;
      return { targetKey, metaKey, ctrlKey, shiftKey, altKey };
    }
    // 如果 target 无效，返回一个默认值，避免报错
    return { targetKey: "", metaKey: false, ctrlKey: false, shiftKey: false, altKey: false };
  };

  // 按键按下时的处理函数
  const handleKeyDown = (event) => {
    const { targetKey, metaKey, ctrlKey, shiftKey, altKey } = getTargetKeyAndModifiers();

    // 判断按键和修饰键是否匹配
    if (
      event.key === targetKey &&
      metaKey === event.metaKey &&
      ctrlKey === event.ctrlKey &&
      shiftKey === event.shiftKey &&
      altKey === event.altKey
    ) {
      event.preventDefault(); // 取消默认行为
      callback(event);
      console.log(event);
    }
  };

  useEffect(() => {
    // 绑定事件监听器
    window.addEventListener("keydown", handleKeyDown);

    // 清理事件监听器
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [target, callback]);

  return;
}

export default useKeyDown;
